<div class="input-group">
  <span class="input-group-btn">
    <button
      type="button"
      style="margin: 0"
      class="btn btn-outline-secondary"
      (click)="doSearch(inputbox.value, true, $event)"
    >
      <mat-icon>search</mat-icon>
    </button>
  </span>
  <input
    #inputbox
    type="text"
    class="form-control"
    (keyup)="change(inputbox.value, $event)"
    [placeholder]="placeHolder"
    [(ngModel)]="searchCriteria"
    name="criteria"
    (keydown.enter)="doSearch(inputbox.value, true, $event)"
    [required]="options.required"
  />
  <span class="input-group-btn" *ngIf="options.showFilterBtn !== false">
    <button
      type="button"
      style="margin: 0"
      class="btn btn-outline-secondary"
      (click)="showFiltersDlg($event)"
    >
      <mat-icon>tune</mat-icon>
    </button>
  </span>
</div>
